import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeftIcon, ShareIcon, FlameIcon, PlayIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { MOCK_VIDEOS } from '../data/mockData';
export function HashtagFeed() {
  const navigate = useNavigate();
  const {
    tag
  } = useParams();
  const gridVideos = [...MOCK_VIDEOS, ...MOCK_VIDEOS, ...MOCK_VIDEOS];
  return <div className="w-full h-full bg-black flex flex-col" data-id="element-401">
      {/* Header */}
      <div className="px-4 py-4 flex items-center justify-between border-b border-border bg-black sticky top-0 z-10" data-id="element-402">
        <button onClick={() => navigate(-1)} className="text-white" data-id="element-403">
          <ArrowLeftIcon size={24} data-id="element-404" />
        </button>
        <h1 className="text-white font-poppins font-bold text-lg" data-id="element-405">#{tag}</h1>
        <button className="text-white" data-id="element-406">
          <ShareIcon size={20} data-id="element-407" />
        </button>
      </div>

      <div className="flex-1 overflow-y-auto no-scrollbar" data-id="element-408">
        {/* Hashtag Hero */}
        <div className="px-6 py-8 flex flex-col items-center text-center border-b border-border" data-id="element-409">
          <div className="w-20 h-20 rounded-full bg-surface border border-border flex items-center justify-center text-4xl font-poppins font-extrabold text-primary mb-4" data-id="element-410">
            #
          </div>
          <h2 className="text-white font-poppins font-bold text-2xl mb-1" data-id="element-411">
            #{tag}
          </h2>
          <div className="flex items-center gap-2 text-softGray text-sm mb-6" data-id="element-412">
            <FlameIcon size={14} className="text-neonOrange" data-id="element-413" />
            <span data-id="element-414">{(Math.random() * 100 + 20).toFixed(1)}M views</span>
          </div>
          <Button onClick={() => navigate('/upload')} className="w-full max-w-[260px]" data-id="element-415">
            Use this hashtag
          </Button>
        </div>

        {/* Video Grid */}
        <div className="grid grid-cols-3 gap-0.5" data-id="element-416">
          {gridVideos.map((video, i) => <button key={`${video.id}-${i}`} onClick={() => navigate('/feed')} className="relative aspect-[3/4] bg-surface group" data-id="element-417">
              <div className={`absolute inset-0 bg-gradient-to-br ${video.color} opacity-80 group-hover:opacity-100 transition-opacity`} data-id="element-418" />
              <div className="absolute bottom-1 left-1 flex items-center gap-1 text-white" data-id="element-419">
                <PlayIcon size={12} className="fill-white" data-id="element-420" />
                <span className="text-[10px] font-bold drop-shadow-md" data-id="element-421">
                  {(Math.random() * 100 + 10).toFixed(1)}K
                </span>
              </div>
            </button>)}
        </div>
      </div>
    </div>;
}